/**
 * Lockup das telas de entrada (login, aceitar convite): "Matéria" fino e claro,
 * "PrimAi" inteiro em dourado, Inter 800.
 *
 * São DOIS lockups de propósito, e a diferença é decidida, não acidental: aqui
 * a marca aparece sozinha e grande, então vai cheia; dentro do sistema
 * (`<Logo />`) só o "Ai" é dourado, para o logo não competir com a navegação.
 * A spec `teladeloginvisual` §6.3 descreve a variante de dentro do sistema.
 */
export function MarcaLogin() {
  return (
    <div className="login-marca">
      <div className="login-marca-nome">
        Matéria<span className="bold amarelo">PrimAi</span>
      </div>
      <div className="login-marca-sub">Eventos inteligentes</div>
    </div>
  );
}

/** Lockup de dentro do sistema: só o "Ai" em dourado. Ver `<MarcaLogin />`. */
export function Logo() {
  return (
    <div className="sidebar-logo">
      <div className="brand">
        Matéria<span className="bold">Prim<span className="ai-yellow">Ai</span></span>
      </div>
      <div className="tagline">Eventos</div>
    </div>
  );
}
